define('uikit/elements/header.with.help.text.view',['require','exports','module','./component.with.help.text'],function(require, exports, module) {
  // prettier-ignore
  var ComponentWithHelpText = require('./component.with.help.text');

  var HeaderWithHelpText = ComponentWithHelpText.extend({
    className: 'ui header',
  });

  module.exports = HeaderWithHelpText;
});

